export enum AdminScope {
  HOLDING = 'holding',
  COMPANY = 'company'
}

export type AdminFormValues = {
  email: string;
  scope?: AdminScope;
  subsidiaryCoreIds: string[];
};

export type EditAdminRouteParams = {
  adminId: string;
};

export type SelectableSubsidiary = {
  coreId: string;
  name: string;
  taxIdentifier: string;
};
